import React from 'react';
import _ from 'lodash';

/**
 * Manage the showing / hiding of header shadow on scroll
 */
export const useHeaderScrollShadow = (hasShadow: boolean) => {
  const [showShadow, setShowShadow] = React.useState(false);

  function onScrollEvent(event: Event) {
    if (!showShadow) {
      setShowShadow(true);
    }
    if (window.scrollY <= 0) {
      setShowShadow(false);
    }
  }

  const debouncedScrollListener = _.debounce(onScrollEvent, 400, { leading: true });

  React.useEffect(() => {
    if (!hasShadow) {
      setShowShadow(false);
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener('scroll', debouncedScrollListener);

    return () => {
      window.removeEventListener('scroll', debouncedScrollListener);
    };
  }, [debouncedScrollListener, hasShadow, showShadow]);

  return showShadow;
};
